const hexToRgb = hex => {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (result) {
    var r = parseInt(result[1], 16);
    var g = parseInt(result[2], 16);
    var b = parseInt(result[3], 16);
    const rgb = r + ',' + g + ',' + b; //return 23,14,45 -> reformat if needed
    return rgb;
  }
  return null;
};
export { hexToRgb };
//# sourceMappingURL=theme-tools.js.map